module.exports = __webpack_public_path__ + "static/img/kwsb.a2fe5ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/kwsb.png
// module id = 9lnk
// module chunks = 0